



















import {Component, Prop, Vue} from 'vue-property-decorator';
import {mixin as clickaway} from 'vue-clickaway';
import {dropDownHelper} from './dropDownHelper';
import AddIcon from 'vue-material-design-icons/PlusCircle.vue';
import CodeIcon from 'vue-material-design-icons/CodeBrackets.vue';
import Dots from 'vue-material-design-icons/DotsVertical.vue';

@Component({
	mixins: [
		clickaway
	],
	components: {
		AddIcon,
		Dots,
		CodeIcon
	}
})
export default class DropDownMenu extends Vue {
	@Prop({default : false}) public goLeft: boolean;
	@Prop({default : 'dots'}) public dropDownIcon: string;
	@Prop({default: false}) public disabled: boolean;
	@Prop({default: false}) public useColourOnActive: boolean;

	public isOpen: boolean = false;
	public isUp: boolean = false;


	public toggleOpen() {
		if (this.disabled) {
			return;
		}

		this.isOpen = !this.isOpen;
		this.refresh();
	}

	public close() {
		this.isOpen = false;
		this.refresh();
	}

	private refresh() {
		this.$nextTick(() => {
			this.isUp = dropDownHelper.isDropDownUp();
			this.$emit('isUp', this.isUp);
			this.$emit('open', this.isOpen);
		});
	}
}
